import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;
import authHeader from "@/services/auth-header";

class UserService {
    searchUser(is_agent, searchquery){
        return axios.get(`${API_URL}/users/search?is_agent=${is_agent}&searchquery=${searchquery}`, {headers: authHeader()});
    }

    fetchUsers(is_agent) {
        return axios.get(`${API_URL}/users/agents/${is_agent}`, {headers: authHeader()});
    }

    fetchUserById(id){
        return axios.get(`${API_URL}/users/${id}/detail` , {headers: authHeader()});
    }

    convertAgentStatus(user_id, agent_form) {
        return agent_form.put(`${API_URL}/users/${user_id}/agent`, {headers: authHeader()});
    }

    fetchPatient(user_id){
        return axios.get(`${API_URL}/users/${user_id}/patients`, {headers: authHeader()});
    }

    fetchPatientCheckupHistory(id,page_no){
        return axios.get(`${API_URL}/users/${id}/patientcheckups/history?page=${page_no}` , {headers: authHeader()});
    }

    fetchUserPayments(id){
        return axios.get(`${API_URL}/users/${id}/transactions/complete`, {headers: authHeader()});
    }
}

export default new UserService();